import { useQuery } from "@tanstack/react-query";
import Queries from "../Common/Queries";
import { getStoreProducts } from "../Pages/Services/storeService";

export default function useGetProductForStores (storeId){
    return useQuery({
        queryKey : [Queries.GET_STORE_PRODCUTS,storeId],
        queryFn : ()=>getStoreProducts(storeId),
        select:(response)=>response.data,
        enabled : !!storeId,
        meta:{errorMessage: "Failed to fetch the products"}
    })
}